import type { FaireProductEntity } from "../../entity_types/product";

export const p_qp3hymq826: FaireProductEntity = {
  token: "p_qp3hymq826",
  type: "product",
  name: "White Clam Shell With Assorted Seashell Pendant Necklace",
  brandName: "DK Hawaii",
  imageUrl:
    "https://cdn.faire.com/fastly/488e5dae21791cdba76ba6a7773ef14310b182e18d731c10b51ac1875b92c999.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8a790caa99e13c6b3a0d99d8401b43d0eb4a9b537d36a83ad20f9fddbd51215f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
